import React from 'react';
import axios from 'axios';
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Button,
  Divider,
  Box,
  Tooltip,
} from '@mui/material';
import DiscountIcon from '@mui/icons-material/Discount';
import TimerIcon from '@mui/icons-material/Timer';
import HomeIcon from '@mui/icons-material/Home';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

// Fetch the base URL from the environment variable
const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const TestCard = ({ test, themeColors }) => {
  const handleAddToCart = async () => {
    const payload = {
      lab_id: test.lab.reference_id,
      lab_item_id: test.reference_id,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/cart`, // Use the base URL dynamically
        payload,
        {
          headers: {
            authorization: '7633d6c7-1111-4fd9-b78c-14e0312957f8',
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('Add to Cart Success:', response.data);
      alert('Item added to cart successfully!');
    } catch (error) {
      console.error('Add to Cart Error:', error);
      alert('Failed to add item to cart. Please try again.');
    }
  };

  return (
    <Card
      sx={{
        boxShadow: 4,
        borderRadius: '12px',
        overflow: 'hidden',
        height: '270px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
        },
      }}
    >
      <CardContent
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: '16px',
        }}
      >
        <Tooltip title={test.name} arrow>
          <Typography
            variant="subtitle2"
            fontWeight="bold"
            sx={{
              fontSize: '15px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              lineHeight: '1.4',
              marginBottom: '8px',
              cursor: 'pointer',
            }}
          >
            {test.name}
          </Typography>
        </Tooltip>

        <Chip
          icon={<DiscountIcon />}
          label={test.discount_tag || 'No Discount'}
          size="small"
          sx={{
            marginBottom: 1,
            color: '#D32F2F',
            fontWeight: 'bold',
            backgroundColor: '#FFF3E0',
          }}
        />

        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <Typography variant="h6" fontWeight="bold" color={themeColors.primary}>
            ₹{test.total_price}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              textDecoration: 'line-through',
              color: themeColors.grey,
            }}
          >
            ₹{test.amount}
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <TimerIcon fontSize="small" sx={{ color: themeColors.blue }} />
          <Typography variant="body2" color={themeColors.text}>
            Report in {test.report_time} mins
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          {test.lab_visit && (
            <Chip
              icon={<LocalHospitalIcon />}
              label="Lab Visit"
              size="small"
              sx={{
                backgroundColor: themeColors.lightGrey,
                color: themeColors.text,
                fontWeight: '500',
              }}
            />
          )}
          {test.home_visit && (
            <Chip
              icon={<HomeIcon />}
              label="Home Visit"
              size="small"
              sx={{
                backgroundColor: themeColors.lightGrey,
                color: themeColors.text,
                fontWeight: '500',
              }}
            />
          )}
        </Box>
      </CardContent>

      <Divider />

      <Box sx={{ padding: '8px' }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: themeColors.green,
            fontWeight: 'bold',
            padding: '10px',
            borderRadius: '8px',
            '&:hover': {
              backgroundColor: themeColors.primary,
            },
          }}
          fullWidth
          onClick={handleAddToCart}
        >
          Add to Cart
        </Button>
      </Box>
    </Card>
  );
};

export default TestCard;